<div class="hamburger">
    <h2>{{heading}}</h2>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <p-toolbar styleClass="toolbar">
          <ng-template pTemplate="left">
          </ng-template>
          <ng-template pTemplate="right">
      
          </ng-template>
        </p-toolbar>
      </div>
    </div>
 
    </div>
    <div class="bg">
      <div class="tableDesign">
        <div class="row">
            <div class="col-md-12">
                <p-toolbar styleClass="toolbar">
                  <ng-template pTemplate="left">
                  </ng-template>
                    <ng-template pTemplate="right">
                        <button pButton pRipple icon="pi pi-plus" iconPos="left"
                            class="p-button-secondary custom-button new-button" (click)="openNew()"
                            styleClass="button">
                            <span class="button-label" [ngClass]="fontService.buttonClass"
                               >Add</span>
                                
                        </button>
                        <!-- <button class="btn btn-primary" styleClass="button" (click)="openNew()">
                          Add +
                        </button> -->
                    </ng-template>
                </p-toolbar>
            </div>
        </div>
        <div class="row">
            <!-- <div class="container bgFilter mb-3">
                <div class="row align-items-center mt-2">

                  <div class="col-sm-4 col-md-3" >
                    <label class="form-control-label req" [ngClass]="fontService.labelClass">Government
                        Type</label>
                    <ng-select id="department" [items]="govermentType"  [(ngModel)]="govermentTypeFiltervalue" bindLabel="name" appearance="outline"
                        [closeOnSelect]="true" [clearable]="true" class="form-control" (change)="getAgency($event)">
                    </ng-select>
                </div>
                <div class="col-sm-4 col-md-3" >
                    <label class="form-control-label req" [ngClass]="fontService.labelClass">Requesting Department</label>
                    <ng-select id="department" [items]="agencyList"  [(ngModel)]="agencyFiltervalue"  bindLabel="agencyName" appearance="outline"
                        [closeOnSelect]="true" [clearable]="true" class="form-control" (change)="getProject($event)"  >
                    </ng-select>
                </div>
                  
                    <div class="col-sm-4 col-md-3">
                        <label class="form-control-label req" [ngClass]="fontService.labelClass">Project
                            Name</label>
                        <ng-select id="department" bindLabel="projectName" bindValue='id'
                             [items]="projectList" [(ngModel)]="projectFiltervalue" appearance="outline"
                            class="form-control">
                        </ng-select>
                    </div>
              
                </div>
                <div class="flex align-items-center mt-3 ">
                    <p-button label="Submit" class="submit" (click)="filterpage()"></p-button>
                </div>
            </div> -->
            <div #customerTable id="entities" class="col-md-11 table_class" *ngIf="isTable">
                <div class="table-scroll">
                    <table class="table">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Fin Year </th>
                            <th>Agency Name</th>
                            <th>From Project </th>
                            <th>To Project</th>
                            <th>Allocated Date</th>
                            <th>Amount </th>
                         <th>Action</th>
                          
                          </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of projectData let i=index">
                              <td>{{i+1}}</td>
               <td>{{data.finYearName}}</td>
               <td>{{data.agencyName}}</td>
                <td>{{data.fromProjectName}}</td>
                <td>{{data.toProjectName}}</td>
                <td> {{data.createdOn |date}}</td>
                <td>{{data.amount}}</td>
                <td *ngIf="data.activeFlag =='New'"> 
                  <a  class="a_tag" (click)="approveRecord(data,'approve')">Approve</a>
                  <a class="a_tag" (click)="approveRecord(data,'reject')">Reject</a>

                </td>
                <td *ngIf="data.activeFlag !=='New'"> 
             <p>-</p>

                </td>

                
                            </tr>
                        </tbody>
                    </table>
                </div>
             
                <!-- <div class="text-center" *ngIf="totalCount == 0">
                    <img src="../../../assets/img/notFound.png" width="419px" alt="">
                </div> -->
                <p-paginator [rows]="itemsPerPage" (onPageChange)="onPageChange($event)" [totalRecords]="totalCount"
                    [rowsPerPageOptions]="[10,20,30,50,100]"></p-paginator>
  
            </div>
        </div>
    </div>
    </div>
   

    <p-dialog #dialog [(visible)]="limitAllocationDialog" [modal]="true" styleClass="ib-dialog" [style]="{ width: '750px' }"
    (onHide)="hideDialog()">
    <p-header [ngClass]="fontService.headingClass">
  Budget Allocation
    </p-header>
    <ng-template pTemplate="content">
      <div class="col-12">
        <div class="form-inner-panel">

          <div class="row gy-2">
            <!-- <div class="col-sm-6 col-md-6">
                <label>Department</label>
                <p style="font: bold;">LAND ACQUISITION AGENCY OF TAMILNADU</p>
             
            </div> -->
            <div class="col-sm-6 col-md-6">
                <label class="form-control-label req" for="date">Fin Year</label>
                <ng-select id="gender" bindLabel="name" [items]="finYear" appearance="outline"
                    [closeOnSelect]="true" [clearable]="false" [(ngModel)]="finYearValue" class="form-control">
                </ng-select>
            </div>
            <div class="col-sm-6 col-md-6">
                <label class="form-control-label " [ngClass]="fontService.labelClass">Category</label>
                <ng-select id="department" [items]="categoryList" [disabled]="true" bindLabel="name" appearance="outline"  bindValue="name" [(ngModel)]="categoryData" (change)="onChangeCategory($event)"
                    [closeOnSelect]="true" [clearable]="true" class="form-control">
                </ng-select>
            </div>
    
            <div class="col-sm-6 col-md-6" >
                <label class="form-control-label req" [ngClass]="fontService.labelClass">Government
                    Type</label>
                <ng-select id="department" [items]="govermentType" bindLabel="name" appearance="outline"
                    [closeOnSelect]="true" [clearable]="true" class="form-control" (change)="getAgency($event)">
                </ng-select>
            </div>
            <div class="col-sm-6 col-md-6" >
                <label class="form-control-label req" [ngClass]="fontService.labelClass">Requesting Department</label>
                <ng-select id="department" [items]="agencyList" [(ngModel)]="agencyValue" bindLabel="agencyName" appearance="outline"
                    [closeOnSelect]="true" [clearable]="true" class="form-control" (change)="getProject($event)"  >
                </ng-select>
            </div>
            
            <div class="col-md-12" >
                <label class="form-control-label req" [ngClass]="fontService.labelClass">From Project</label>
                <ng-select id="department" [items]="projectList" bindLabel="projectName" appearance="outline"
                    [closeOnSelect]="true" [clearable]="true" class="form-control" [(ngModel)]="fromProjectValue"   (change)="fromProjectChange($event)">
                </ng-select>
            </div>
            <div *ngIf="fromProjectAmount" class="col-sm-6 col-md-6">
              <label>From Project Available Amount</label>

      <p class="mt-2">{{fromProjectAmount}}</p>
           
          </div>
      
            <div class="col-md-12" *ngIf="fromProjectAmount">
              <label class="form-control-label req" [ngClass]="fontService.labelClass">To Project</label>
              <ng-select id="department" [items]="toProjectList" bindLabel="projectName" appearance="outline"
                  [closeOnSelect]="true" [clearable]="true" class="form-control" [(ngModel)]="toProjectValue"  (change)="toProjectChange($event)">
              </ng-select>
          </div>

          <div *ngIf="toProjectAmount" class="col-sm-6 col-md-6">
            <label>To Project Available Amount</label>
            <p class="mt-2">{{toProjectAmount}}</p>
         
        </div>
            <div class="col-sm-6 col-md-6">
                <label class="form-control-label req">Amount</label>
               <input class="form-control" [(ngModel)]="toProjectAllocatedAmount" />
             
            </div>
          </div>
        
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button icon="pi pi-times" class="btn btn-primary" (click)="hideDialog()">
        <span class="button-label" [ngClass]="fontService.buttonClass" custom-button >Cancel
        </span>
      </button>
      <button  icon="pi pi-check" class="btn btn-primary" (click)="saveLimit()">
        <span class="button-label" [ngClass]="fontService.buttonClass" > Save</span>
      </button>
    </ng-template>
  </p-dialog>
  <!-- <p-dialog #dialog [(visible)]="limitcorrectionDialog" [modal]="true" styleClass="ib-dialog" [style]="{ width: '750px' }"
  (onHide)="hideDialog()">
  <p-header [ngClass]="fontService.headingClass">
Budget Correction
  </p-header>
  <ng-template pTemplate="content">
    <div class="col-12">
      <div class="form-inner-panel">

        <div class="row gy-2">
          <div class="col-sm-6 col-md-6">
              <label>Department</label>
              <p style="font: bold;">LAND ACQUISITION AGENCY OF TAMILNADU</p>
           
          </div>
          <div class="col-sm-6 col-md-6">
              <label class="form-control-label" for="date">Fin Year</label>
              <ng-select id="gender" bindLabel="name" [items]="finYear" appearance="outline"
                  [closeOnSelect]="true" [clearable]="false" class="form-control">
              </ng-select>
          </div>
          <div class="col-sm-6 col-md-6">
              <label class="form-control-label req" [ngClass]="fontService.labelClass">Category</label>
              <ng-select id="department" [items]="categoryList" bindLabel="name" appearance="outline" readonly  bindValue="name" [(ngModel)]="categoryData" (change)="onChangeCategory($event)"
                  [closeOnSelect]="true" [clearable]="true" class="form-control">
              </ng-select>
          </div>
          <div class="col-sm-6 col-md-6">
              <label>Limit Amount</label>
              <p class="mt-2">10000</p>
           
          </div>
          <div class="col-sm-6 col-md-6" *ngIf="isType">
              <label class="form-control-label req" [ngClass]="fontService.labelClass">Government
                  Type</label>
              <ng-select id="department" [items]="govermentType" bindLabel="name" appearance="outline"
                  [closeOnSelect]="true" [clearable]="true" class="form-control">
              </ng-select>
          </div>
          <div class="col-sm-6 col-md-6" *ngIf="isType">
              <label class="form-control-label req" [ngClass]="fontService.labelClass">Agency</label>
              <ng-select id="department" [items]="agencyList" bindLabel="name" appearance="outline"
                  [closeOnSelect]="true" [clearable]="true" class="form-control">
              </ng-select>
          </div>
          <div class="col-sm-6 col-md-6" *ngIf="isProject">
              <label class="form-control-label req" [ngClass]="fontService.labelClass">Project</label>
              <ng-select id="department" [items]="projectList" bindLabel="name" appearance="outline"
                  [closeOnSelect]="true" [clearable]="true" class="form-control">
              </ng-select>
          </div>
          <div class="col-sm-6 col-md-6">
            <label>Allocated Amount</label>
            <p class="mt-2">10000</p>
            <input class="form-control" /> 
         
        </div>
          <div class="col-sm-6 col-md-6">
              <label>Amount</label>
             <input class="form-control" />
           
          </div>
        </div>
      
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button icon="pi pi-times" class="btn btn-primary" (click)="hideDialog()">
      <span class="button-label" [ngClass]="fontService.buttonClass" custom-button >Cancel
      </span>
    </button>
    <button  icon="pi pi-check" class="btn btn-primary" (click)="saveLimit()">
      <span class="button-label" [ngClass]="fontService.buttonClass" > Save</span>
    </button>
  </ng-template>
</p-dialog> -->
<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>